'use client';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '../server/layout/Stack/index';
import { Row } from '../server/layout/Row/index';
import { useInteractive } from '../system/interactive';
import { MOTION } from '../system/motion';
export function RailRow({ active, accent, leadingTone, bordered = true, last, onClick, padding, padX, padY, gap, leading, title, sub, columns, trailing, children, style, }) {
    const isActive = active || leadingTone === 'selected' || leadingTone === 'unread';
    const rail = isActive ? (accent ?? 'var(--primary)') : 'transparent';
    const showBorder = bordered && !last;
    const pad = padding ?? `var(--space-${padY ?? 'md'}) var(--space-${padX ?? 'lg'})`;
    const interactive = !!onClick;
    const { state, bind } = useInteractive({ onClick });
    const bg = isActive
        ? 'var(--accent)'
        : interactive && state.active
            ? 'var(--accent)'
            : interactive && state.hover
                ? 'var(--background)'
                : 'transparent';
    const usingSlots = leading != null || title != null || sub != null || columns != null || trailing != null;
    const inner = usingSlots ? (_jsxs(Row, { gap: gap ?? 'md', align: "center", wrap: false, style: { width: '100%' }, children: [leading, (title != null || sub != null) && (_jsxs(Stack, { gap: "xs", style: { flex: 1, minWidth: 0 }, children: [title, sub] })), columns, trailing && _jsx("div", { style: { flexShrink: 0 }, children: trailing })] })) : children;
    return (_jsx(Row, { align: "center", wrap: false, gap: usingSlots ? undefined : (gap ?? 'md'), ...(interactive ? bind : {}), style: {
            padding: pad,
            background: bg,
            borderLeft: `var(--border-thicker) solid ${rail}`,
            borderBottom: showBorder ? '1px solid var(--border)' : 'none',
            cursor: interactive ? 'pointer' : 'default',
            transition: MOTION.transition,
            ...style,
        }, children: inner }));
}
//# sourceMappingURL=RailRow.js.map